<template>
    <HeaderComponent :title="`Edit Report for ${affiliate.name}`" :actions="[
        {label: 'Save Report', click: () => editReport(), class: 'bg-green-500 text-white'}, 
    ]"/>
    <FormKit type="form" submit-label="Edit Report" @submit="editReport" :actions="false">
        <FormKit type="text" name="type" label="Type" v-model="form.type" />
        <FormKit
            type="text"
            name="period"
            label="Period"
            v-model="form.period"
        />
        <FormKit
            type="text"
            name="description"
            label="Description"
            v-model="form.description"
        />
        <FormKit
            type="number"
            name="amount"
            label="Amount"
            number="float"
            validation="required|min:0"
            step="0.01"
            v-model="form.amount"
        />
        <FormKit
            type="datetime-local"
            name="created"
            label="Created"
            v-model="form.created"
        />
    </FormKit>
</template>

<script setup>
import { usePage, router } from "@inertiajs/vue3";
import { computed, ref } from "vue";
import { FormKit } from "@formkit/vue";
import HeaderComponent from "@/Components/HeaderComponent.vue";

const page = usePage();

const affiliate = computed(() => page.props.affiliateReport.affiliate);
const affiliateReport = computed(() => page.props.affiliateReport);

const form = ref({
    type: affiliateReport.value.type,
    period: affiliateReport.value.period,
    description: affiliateReport.value.description,
    amount: affiliateReport.value.amount,
    created: (new Date(affiliateReport.value.created)).toISOString().substr(0, 16)
});

const editReport = () => {
    router.post(
        `/admin/affiliate-reports/edit/${affiliateReport.value.id}`,
        {
            affiliateReport: form.value,
        },
        {
            headers: {
                "X-CSRF-Token": page.props.csrfToken,
            },
        },
    );
};
</script>
